import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import mapValues from 'lodash/mapValues';

export const isDate = (x: any): x is Date => {
  return typeof x === 'object' && x.constructor === Date;
};

/**
 * nullかundefinedではないかチェックする
 * @param x value
 */
export const notUndefinedOrNull = <T>(x: T | undefined | null): x is T => {
  return x !== undefined && x !== null;
};

/**
 * 文字列が空かチェックする
 * @param value
 */
export const isNotEmpty = (value: string) => {
  return value !== '';
};

/**
 * undefined、nullまたはEmptyStringでないかをチェックする
 * @param x value
 */
export const notUndefinedOrNullOrEmpty = <T extends string>(
  x: T | undefined | null
): x is T => {
  if (notUndefinedOrNull(x)) {
    return isNotEmpty(x);
  } else {
    return false;
  }
};

/**
 * 空文字をundefinedとする
 * @param value
 */
export const emptyStringToUndefined = (
  value: string | undefined | null
): string | undefined => {
  if (notUndefinedOrNull(value)) {
    return isNotEmpty(value) ? value : undefined;
  } else {
    return undefined;
  }
};

export const undefinedToNull = (data: any) => {
  if (typeof data !== 'object') return data;
  if (Array.isArray(data))
    return data.map(item => {
      return undefinedToNull(item);
    });
  if (data === null) return null;
  if (isDate(data)) return data;

  return Object.entries(data)
    .map(([key, value]) => {
      if (typeof value === 'object' && value !== null) {
        return [key, undefinedToNull(value)];
      } else if (typeof value === 'undefined') {
        return [key, null];
      } else {
        return [key, value];
      }
    })
    .reduce((result, [key, value]) => {
      const newValue = {};
      newValue[key] = value;
      return Object.assign(result, newValue);
    }, {});
};

// 配列内のnullは無判別
export const nullToUndefined = (value: any) => {
  if (isPlainObject(value)) {
    return mapValues(value, nullToUndefined);
  }
  if (isArray(value)) {
    return value.map(nullToUndefined);
  }
  if (value === null) {
    return undefined;
  }
  return value;
};
